import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.kiosk');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-layout-kiosk',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.kiosk/view.scss */
/* src/app/layout.kiosk/view.scss: no such file or directory */`],
})
export class LayoutKioskComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default LayoutKioskComponent;